import { Text, View } from '@react-pdf/renderer';

import { getContractPropertyAddress } from '@/utils/contractPropertyAddress';
import {
  getPropertyConditionClause,
  REPAIRS_LEAD_IN,
} from '@/utils/propertyConditionClause';
import { Contract } from '@/types/ContractType';
import { styles } from '../style';

export const PropertyInfo = ({ contract }: { contract: Contract }) => {
  const prop = getContractPropertyAddress(contract as any);
  const condition = getPropertyConditionClause(contract?.offerSpecifics as any);
  return (
    <View style={styles.section}>
      <Text style={styles.title}>PROPERTY INFORMATION</Text>
      <View style={styles.list}>
        <Text>
          1. By this agreement Seller agrees to sell and Buyer agrees to buy the
          real property located at:{' '}
          <Text style={styles.bold}>{prop.addressLine || 'N/A'}</Text>
        </Text>
        <Text>
          2. The Property is located in:{' '}
          <Text style={styles.bold}>
            {(prop.city ||
              contract?.sellerPropertyInfo?.propertyCounty ||
              contract?.agentSellerInfo?.propertyCounty ||
              'N/A') + ','}{' '}
            {(prop.state || 'N/A') + ' ' + (prop.zip || '')}
          </Text>
        </Text>
        <Text>
          3. The Property is legally described as follows
          <Text style={styles.bold}>
            {': '}
            {contract?.agentSellerInfo?.legalDescription ?? 'N/A'}
          </Text>
        </Text>
        <Text>
          4. <Text style={styles.bold}>{condition.statement}</Text>
        </Text>
        {condition.repairs.length > 0 && (
          <View style={styles.subList}>
            <Text>a. {REPAIRS_LEAD_IN}</Text>
            {condition.repairs.map((r) => (
              <Text key={r} style={styles.bold}>
                {'   • '}
                {r}
              </Text>
            ))}
          </View>
        )}
      </View>
    </View>
  );
};
